/* Keeps the document <title> and meta description in sync with the
   published content. The static tags in index.html cover crawlers /
   social cards (which don't run JS); this updates what a live visitor
   and JS-aware engines see, from the owner-edited hero copy. */
import { useEffect } from 'react'
import { useContent } from '../content/ContentContext.jsx'

function setMeta(name, value) {
  if (!value) return
  let el = document.querySelector(`meta[name="${name}"]`)
  if (!el) {
    el = document.createElement('meta')
    el.setAttribute('name', name)
    document.head.appendChild(el)
  }
  el.setAttribute('content', value)
}

export function useDocumentMeta() {
  const { content } = useContent()
  const h = content?.hero
  useEffect(() => {
    if (!h) return
    const headline = `${h.pre || ''}${h.em || ''}${h.post || ''}`.trim()
    const brand = content.brand || 'CuratedHomes'
    document.title = headline ? `${brand} — ${headline}` : `${brand} — Advisory`
    if (h.sub) setMeta('description', h.sub)
  }, [content, h])
}
